export default __webpack_public_path__ + "static/media/icon-arrow-right.6924e8e8.png";